import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {
        typesConnection: undefined,
        listConnections: undefined,
        listSettings: undefined,
        typesSetting: undefined
    }
};
export default createReducer(initialState, {
    [actionTypes.GET_SETTINGS_TYPE_DICTIONARY_COMPLETED]: (state, { payload }) => {
        const result = set(state, `[${NAMESPACE}].typesConnection`, mapValues(keyBy(payload.connections, "Id"), "Name"));
        return set(result, `[${NAMESPACE}].typesSetting`, mapValues(keyBy(payload.settings, "Id"), "Name"));
    },
    [actionTypes.GET_SETTINGS_COMPLETED]: (state, { payload }) => {
        const result = set(state, `[${NAMESPACE}].listConnections`, keyBy(payload.connections, "Type"));
        return set(result, `[${NAMESPACE}].listSettings`, keyBy(payload.settings, "Type"));
    },
    [actionTypes.SAVE_SETTING_COMPLETED]: (state, { payload }) => state[NAMESPACE].listSettings
        ? set(state, `[${NAMESPACE}].listSettings[${payload.Type}]`, payload)
        : state,
    [actionTypes.SAVE_CONNECTION_COMPLETED]: (state, { payload }) => state[NAMESPACE].listConnections
        ? set(state, `[${NAMESPACE}].listConnections[${payload.Type}]`, payload)
        : state
});
